export function PhoneField({ value, onChange, testid }) {
  return (
    <div className="flex items-stretch">
      <span className="inline-flex items-center px-3 border border-r-0 rounded-l-md bg-[hsl(var(--muted)/0.08)] text-sm text-[hsl(var(--muted))] select-none" data-testid={`${testid}-prefix`}>+91</span>
      <input
        className="input-field rounded-l-none"
        inputMode="numeric"
        maxLength={10}
        placeholder="10-digit number"
        value={value}
        onChange={(e) => onChange(e.target.value.replace(/\D/g, "").slice(0, 10))}
        data-testid={testid}
      />
    </div>
  );
}
